<template>
  <v-select
      :items="combo"
      :value="value"
      @input="alteraValor"
      :label="label"
      :placeholder="placeholder"
      v-validate="{ required: isRequired }"
      :name="name"
      :error-messages="errors.collect(`${name}`)"
      :disabled="disabled"
      :menu-props="{ top: false, offsetY: true }"
      :outline="outline"
  ></v-select>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'AzComboEnumLicitacao',
  props: {
    enumObject: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    },
    disabled:{
      default: false
    }
  },
  inject: ['$validator'],
  data() {
    return {
      combo: []
    }
  },
  beforeMount() {
    this.combo = this.converteParaCombo(this.enumObject)
  },
  methods: {
    alteraValor(event) {
      this.$emit('input', event)
    },
    converteParaCombo(objeto) {
      let novoArray = []

      if (objeto) {
        for (let [chave, valor] of Object.entries(objeto)) {
          novoArray.push({ text: valor, value: chave })
        }
        novoArray = _.sortBy(novoArray, 'text')
      }

      return _.union([{ text: this.placeholder, value: null }], novoArray)
    }
  },
  watch: {
    enumObject: {
      handler(novoValor) {
        this.combo = this.converteParaCombo(novoValor)
      }
    }
  }
}
</script>
